import React from "react";
import { ArrowDownUp } from "react-bootstrap-icons";
import moment from "moment";
import FormatNumber from "../../components/common/NumberFormat";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Badge } from "react-bootstrap";
import { badge } from "../../components/common/Utils";
import { adminResellerCommission } from "../../pages/reseller/resellerCollection/CommissionShear";
import useISPowner from "../../hooks/useISPOwner";

const PrintReport = React.forwardRef((props, ref) => {
  const { t } = useTranslation();

  const { currentCustomers, filterData } = props;

  //---> Get user & current user data form useISPOwner hooks
  const { role, ispOwnerData, userData, resellerData } = useISPowner();

  const startDate = moment(filterData.startDate).format("DD/MM/YYYY");
  const endDate = moment(filterData.endDate).format("DD/MM/YYYY");

  const resellerInfo = role === "collector" ? resellerData : userData;

  return (
    <>
      <div ref={ref}>
        <div className="page_header letter_header d-flex justify-content-between align-items-center pb-3 ">
          <div className="logo_side">
            <div className="company_logo">
              <img src="/assets/img/logo.png" alt="" />
            </div>
            <div className="company_name">{ispOwnerData.company}</div>
          </div>
          <div className="details_side">
            <p>
              {t("companyName")} {ispOwnerData.company}
            </p>
            {ispOwnerData.address && (
              <p>
                {t("address")} : {ispOwnerData?.address}
              </p>
            )}
          </div>
        </div>

        <ul className="d-flex justify-content-evenly mb-1">
          <li>
            {t("area")} : {filterData.area}
          </li>
          <li>
            {t("subArea")} : {filterData.subArea}
          </li>
          <li>
            {t("collector")} : {filterData.collector}
          </li>
          <li>
            {t("date")} : {startDate} - {endDate}
          </li>
        </ul>

        <ul className="d-flex justify-content-evenly mb-1">
          <li>
            {t("totalData")} {currentCustomers.length}
          </li>

          <li className="ms-4">
            {t("totalBill")}: ৳{filterData.totalBill}
          </li>
        </ul>

        <table className="table table-striped ">
          <thead>
            <tr className="spetialSortingRow">
              <th scope="col">{t("id")}</th>

              <th scope="col">{t("pppoeIp")}</th>

              <th scope="col">{t("package")}</th>

              <th scope="col">{t("due")}</th>

              <th scope="col">{t("medium")}</th>

              <th scope="col">{t("collected")}</th>

              <th scope="col">{t("commission")}</th>

              <th scope="col">{t("note")}</th>

              <th scope="col">{t("date")}</th>
            </tr>
          </thead>
          <tbody>
            {currentCustomers.map((row, key) => (
              <tr key={key} id={row?.id} className="my-1">
                <td className="prin_td align-middle">
                  <p className="text-center">
                    {row?.hotspotCustomer
                      ? row?.hotspotCustomer?.customerId
                      : row?.customer?.customerId}
                  </p>
                  <p style={{ fontWeight: "600" }}>
                    {row.customer?.userType === "pppoe"
                      ? "PPPoE"
                      : row.customer?.userType === "static"
                      ? "Static"
                      : row.hotspotCustomer?.userType === "hotspot"
                      ? "Hotspot"
                      : ""}
                  </p>
                </td>

                <td className="prin_td align-middle">
                  <p>{row.customer?.name}</p>
                  <p>
                    {row?.customer?.userType === "pppoe"
                      ? row?.customer?.pppoe?.name
                      : row?.customer?.queue?.target}
                  </p>
                </td>

                <td className="prin_td align-middle">
                  <p>
                    {row.customer?.userType === "pppoe"
                      ? row.customer?.mikrotikPackage?.name
                      : row.customer?.userType === "static"
                      ? `${
                          row.customer?.uploadPackage
                            ? row.customer?.uploadPackage?.name
                            : row.customer?.mikrotikPackage?.name
                        }/${
                          row.customer?.downloadPackage
                            ? row.customer?.downloadPackage?.name
                            : row.customer?.mikrotikPackage?.name
                        }`
                      : row.hotspotCustomer?.hotspotPackage?.name}
                  </p>
                  <p style={{ fontWeight: "500" }}>৳{row?.amount}</p>
                </td>

                <td className="prin_td align-middle">
                  <p>{FormatNumber(row?.due)}</p>
                </td>

                <td className="prin_td align-middle text-center text-capitalize">
                  <p style={{ fontWeight: "500" }}>{row?.medium}</p>
                  <p style={{ fontWeight: "600" }}>{row?.billingType}</p>
                </td>

                <td className="prin_td align-middle">
                  <p>{row?.name}</p>
                </td>

                <td className="prin_td align-middle">
                  <p>
                    {t("admin")} &nbsp;
                    <span style={{ fontWeight: "500" }}>
                      ৳
                      {row?.ispOwnerCommission
                        ? row?.ispOwnerCommission
                        : adminResellerCommission(resellerInfo, row, "reseller")
                            ?.ispOwnerCommission}
                    </span>
                  </p>

                  <p>
                    {t("own")} &nbsp;
                    <span style={{ fontWeight: "500" }}>
                      ৳
                      {row?.resellerCommission
                        ? row?.resellerCommission
                        : adminResellerCommission(resellerInfo, row, "reseller")
                            ?.resellerCommission}
                    </span>
                  </p>
                </td>

                <td className="prin_td align-middle">
                  <p>{row?.month}</p>
                </td>

                <td className="prin_td align-middle">
                  <p>{moment(row?.createdAt).format("YYYY-MM-DD HH:mm A")}</p>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
});

export default PrintReport;
